module.exports = "img/element-desktop-logo.f4b4c62.svg";